import {checkIncluded, findReportTypeSection} from 'ducks/reportSections';
import {storedComparableItems} from 'api/reports/comparable/StoredComparableItems';
import {makeFeaturedPropertySection} from 'api/reports/cma/FeaturedSectionFactory';

export const insertFeaturedPropertyPages = (reportSections, sections, comparables) => {
  ['COMPARABLE_SALES', 'COMPARABLE_LISTINGS', 'COMPARABLE_RENTALS']
    .filter(cs => {
      const section = findReportTypeSection(reportSections, cs);
      return section && checkIncluded(section, comparables);
    })
    .filter(cs => reportSections.some(({key}) => key === cs))
    .forEach(sectionName => {
      const comparableItems = storedComparableItems(sectionName);
      const featured = comparableItems.selected
        .filter(propertyId => comparableItems.featured.includes(propertyId))
        .map(propertyId => makeFeaturedPropertySection(propertyId, sectionName, reportSections));
      const start = sections.findIndex(({name}) => name === sectionName);
      sections.splice(start, 0, ...featured);
    });
};
